export var focusBrowseButton = function (component) {
    var _a, _b;
    (_b = (_a = component.node) === null || _a === void 0 ? void 0 : _a.querySelector('.awsui-s3-in-context-fields__browse button')) === null || _b === void 0 ? void 0 : _b.focus();
};
export var focusUriInput = function (component) {
    var _a, _b;
    (_b = (_a = component.node) === null || _a === void 0 ? void 0 : _a.querySelector('.awsui-s3-in-context-fields__uri input')) === null || _b === void 0 ? void 0 : _b.focus();
};
export var focusFilteringInput = function (component) {
    var _a, _b;
    (_b = (_a = component.node) === null || _a === void 0 ? void 0 : _a.querySelector('.awsui-table-filtering-container input')) === null || _b === void 0 ? void 0 : _b.focus();
};
//# sourceMappingURL=focus-controller.js.map